import React from 'react';
import { Box, Skeleton } from '@mui/material';

const UserProfileSkeleton = () => {
  return (
    <Box className="user-profile-skeleton" sx={{ padding: '30px' }}>
      {/* Header Skeleton */}
      <Box display="flex" alignItems="center" gap={3} mb={4}>
        {/* Profile Image */}
        <Skeleton
          variant="circular"
          width={150}
          height={150}
          animation="wave"
        />

        {/* User info */}
        <Box flex={1}>
          <Skeleton variant="text" width="50%" height={35} animation="wave" />
          <Skeleton variant="text" width="40%" height={25} animation="wave" />
          <Skeleton variant="rectangular" width="80%" height={20} animation="wave" sx={{ mt: 2 }} />
        </Box>
      </Box>

      <Box display="flex" alignItems="flex-start" gap={4}>
        {/* Left Sidebar Details */}
        <Box sx={{ flex: '0 0 350px' }}>
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width="100%"
              height={80}
              animation="wave"
              sx={{ borderRadius: '8px', mb: 2 }}
            />
          ))}
        </Box>

        {/* Right Section (Photos + About) */}
        <Box flex={1}>
          <Skeleton variant="text" width="40%" height={30} animation="wave" sx={{ mb: 2 }} />

          {/* Photo Grid Skeleton */}
          <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(150px, 1fr))" gap={2}>
            {[...Array(6)].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width="100%"
                height={120}
                animation="wave"
                sx={{ borderRadius: '8px' }}
              />
            ))}
          </Box>

          {/* About Section */}
          <Box sx={{ mt: 4 }}>
            <Skeleton variant="text" width="30%" height={25} animation="wave" sx={{ mb: 1 }} />
            {[...Array(3)].map((_, index) => (
              <Skeleton
                key={index}
                variant="text"
                width={`${80 - index * 10}%`}
                height={20}
                animation="wave"
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserProfileSkeleton;
